import React from 'react';
import { Col, Input,Form } from 'antd';
import { injectIntl,FormattedMessage } from 'react-intl';
import OutputLocations from '../../../CompoundComponents/MultiLocationWrapper/OutputLocations/OutputLocations';
import MultiLocationWrapper from '../../../CompoundComponents/MultiLocationWrapper/MultiLocationWrapper';
import LocationRegionSelectDropdown from '../../../CompoundComponents/LocationWrapper/LocationRegionSelectDropdown/LocationRegionSelectDropdown';
import CountrySelect from '../../../CompoundComponents/MultiLocationWrapper/CountrySelect/CountrySelect';
import LocationSelect from '../../../CompoundComponents/MultiLocationWrapper/LocationSelect/LocationSelect';
import MileSelect from '../../../CompoundComponents/MultiLocationWrapper/MileSelect/MileSelect';
import RegionSelect from '../../../CompoundComponents/MultiLocationWrapper/RegionSelect/RegionSelect';
import EnhancedAddLocationButton from '../../../CompoundComponents/MultiLocationWrapper/EnhancedAddLocationButton/EnhancedAddLocationButton';
import LocationWrapper from '../../../CompoundComponents/LocationWrapper/LocationWrapper';
import PrimaryLocationRadio from '../../../CompoundComponents/MultiLocationWrapper/PrimaryLocationRadio/PrimaryLocationRadio';
import styles from './JobMultiLocationInput.module.scss';
import { locationLayers } from '../../../Utils/LocationUtils';
import message from '../../../Containers/ManualSearchV2/ManualSearchMessages';

function EnhancedJobMultiLocationInput(props) {
  const {
    locations,
    onChange,
    isLocationSelectionLimitReached,
    isRegionSelectionLimitReached,
    defaultMilesObject,
    countryOptions,
    isCountryWideSearchEnabledCountry,
    form,
    isDistanceDisabled,
    intl,
    isEditDisabled,
  } = props;
  const InputGroup = Input.Group;
  const key = locations?.[locations.length - 1]?.Id || null;
  const isFirstELement = locations?.length === 1;
  const location = locations?.[locations.length - 1] || null;
  const locationContext = form.getFieldValue('LocationContext');
  const isDisable = !isFirstELement || isDistanceDisabled;
  return (
    <MultiLocationWrapper
      onChange={onChange}
      currentKey={key}
      locations={locations}
      currentLocation={location}
      isLocationSelectionLimitReached={isLocationSelectionLimitReached}
      isRegionSelectionLimitReached={isRegionSelectionLimitReached}
      isCountryWideSearchEnabledCountry={isCountryWideSearchEnabledCountry}
      countryOptions={countryOptions}
      defaultMiles={defaultMilesObject}
      layers={locationLayers}
      form={form}
      isEditDisabled={isEditDisabled}
    >
      <div style={{ display: 'flex', flexDirection: 'row', gap: '35px', width: 'max-content' }}>
        <div style={{ width: '140px' }}>
          <LocationWrapper form={form} layers={locationLayers}>
            <LocationRegionSelectDropdown
              size="large"
              initialValue="Location"
              isCountryWideSearchEnabledCountry={isCountryWideSearchEnabledCountry}
              onChange={onChange}
              currentLocation={location}
              sourcingLocations={locations}
              isEditDisabled={isEditDisabled}
            />
          </LocationWrapper>
        </div>

        {locationContext === 'Location' ? (
          <InputGroup compact style={{ width: '650px', display: 'flex', flexDirection: 'row' }}>
            <div style={{ minWidth: '120px', width: 'max-content' }}>
              {' '}
              <CountrySelect isDisabled={isDisable} />
            </div>
            <div style={{ width: 'max-content', minWidth: '240px' }}>
              <LocationSelect
                placeholder={intl.formatMessage({ ...message.cityStateZIPCode })}
                isRemoteJobChecked={isDistanceDisabled}
              />
            </div>
            <div style={{ paddingLeft: '20px', minWidth: 'fit-content', maxWidth: '124px' }}>
              <MileSelect
                locationType="MultiLocation"
                isCountryWideSearchEnabled={isCountryWideSearchEnabledCountry}
                initialRange={defaultMilesObject}
                isRemoteJob={isDistanceDisabled}
                currentKey={key}
                form={form}
                currentLocation={location}
                locationContext={locationContext}
              />
            </div>
            <div className={styles.primaryLocation}>
              <PrimaryLocationRadio />
              <FormattedMessage {...message.primaryLocationLabel} />
            </div>
          </InputGroup>
        ) : (
          // <Row gutter="16">
          <>
            {' '}
            <InputGroup compact style={{ width: '', maxWidth: 'fit-content' }}>
              <div style={{ minWidth: '120px', width: 'max-content' }}>
                {' '}
                <CountrySelect isDisabled={isDisable} />
              </div>
              <div style={{ width: '200px' }}>
                <RegionSelect isRemoteJobChecked={isDistanceDisabled || isCountryWideSearchEnabledCountry} />
              </div>
              <Col span={7}>
                <div style={{ paddingLeft: '20px', width: '' }}>
                  {' '}
                  <MileSelect
                    locationType="MultiLocation"
                    isCountryWideSearchEnabled={isCountryWideSearchEnabledCountry}
                    initialRange={defaultMilesObject}
                    isRemoteJob={isDistanceDisabled}
                    currentKey={key}
                    form={form}
                    currentLocation={location}
                    locationContext={locationContext}
                  />
                </div>
              </Col>
            </InputGroup>
            {/* </Row> */}
          </>
        )}
        <EnhancedAddLocationButton
          isRemoteJobChecked={isDistanceDisabled}
          locationContext={locationContext}
          isFirstELement={isFirstELement}
          currentLocation={location}
        />
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          margin: '18px 0px 18px',
          width: '900px',
          flexWrap: 'wrap',
        }}
      >
        <OutputLocations isRemoteJobChecked={isDistanceDisabled} form={form} isAdvanceSearch displayPrimaryLocation />
      </div>
    </MultiLocationWrapper>
  );
}


export default (injectIntl(Form.create()(EnhancedJobMultiLocationInput)));
